module.exports = __webpack_public_path__ + "img/close-icon-light.30b45c51.svg";